import type {Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntryId} from '../../domain/weight-entry';
import type {WeightTrackingRepository} from '../ports/weight-tracking.repository';

export type DeleteWeightEntryInput = {
  readonly weightEntryId: WeightEntryId;
};

export class DeleteWeightEntry implements UseCase<[DeleteWeightEntryInput], void> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(input: DeleteWeightEntryInput): Promise<Result<void, WeightTrackingError>> {
    return this.repository.deleteEntry(input.weightEntryId);
  }
}
